module.exports = __webpack_public_path__ + "fonts/dmsans-regular-webfont.7bf7bad.woff";